import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { SessionService } from "@app/shared/services/session.service";
import { DialogService } from 'primeng/dynamicdialog';
import { PermissionService } from '@src/app/shared/services/permission.service';

@Component({
    selector: 'app-login',
    templateUrl: './disabled.component.html',
    styleUrls: ['./disabled.component.scss'],
    host: {
        class: 'app-disabled'
    },
    providers: [DatePipe, DialogService],
    standalone: false
})
export class DisabledComponent implements OnInit {

  constructor(
    private dialogService: DialogService,
    public translate: TranslateService,
    public sessionService: SessionService,
    public permissionService: PermissionService,
    public router: Router,
    public route: ActivatedRoute) { }

  ngOnInit(): void {

  }

  submitOnPressEnter(event: any) {
    if (event.keyCode === 13) {
      this.login();
    }
  }

  async login() {
    this.router.navigate(['login']);
  }

}
